import React from 'react';
import styled from 'styled-components';
import { Accordion } from '@latitude/accordion';
import InfoBox from '@/components/InfoBox/InfoBox';
import { FONT_SIZE, FONT_WEIGHT, MARGIN } from '@/utils/constants';
import { Text } from '@latitude/text';

const StyledAccordion = styled(Accordion)`
  margin-top: ${MARGIN.M16};
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.M8};
`;

const BoldText = styled(Text)`
  font-weight: ${FONT_WEIGHT.SEMI_BOLD};
`;

const StyledUL = styled.ul`
  margin-block-start: 0;
`;

const StyledLI = styled.li`
  font-size: ${FONT_SIZE.NORMAL};
  font-weight: ${FONT_WEIGHT.LIGHT};
`;

const ImportantInfoBox = () => (
  <InfoBox>
    <Text>
      Make sure your documents shows everything — we can't accept documents that
      are cropped, blurred, or have redacted information The document needs to
      be in the right file format. We accept PDF, PNG, JPE, JPEG, TIF and TIFF.
    </Text>
  </InfoBox>
);

const accordionData = [
  {
    id: 'Permanent Full or Part Time / Fixed Term Contract',
    title: 'Permanent Full or Part Time / Fixed Term Contract',
    content: (
      <ContentBox>
        <ImportantInfoBox />
        <Text>Please provide us with any one of the following documents:</Text>

        <div>
          <BoldText>Payslips</BoldText>
          <StyledUL>
            <StyledLI>
              Is a PDF, screenshot or photo of a full computer-generated payslip
            </StyledLI>
            <StyledLI>Shows your full name</StyledLI>
            <StyledLI>Your employer's name</StyledLI>
            <StyledLI>
              Most recent payment is dated within the last 31 days
            </StyledLI>
            <StyledLI>
              Includes <strong> minimum 2 months of year-to-date </strong>{' '}
              income or supply <strong> 2 consecutive payslips</strong>
            </StyledLI>
            <StyledLI>
              Shows either Net or Gross income and frequency of pay
            </StyledLI>
          </StyledUL>
        </div>
        <div>
          <BoldText>Bank Statement / Online Transaction History</BoldText>
          <StyledUL>
            <StyledLI>Shows your BSB, account number & account name</StyledLI>
            <StyledLI>
              Two months of income payments, most recent income showing within
              the last 31 days
            </StyledLI>
            <StyledLI>
              Employer's name or ACN/ABN corresponding to the deposits
            </StyledLI>
          </StyledUL>
        </div>
      </ContentBox>
    )
  },
  {
    id: 'Casual / Seasonal / Temporary',
    title: 'Casual / Seasonal / Temporary',
    content: (
      <ContentBox>
        <ImportantInfoBox />
        <Text>Please provide us with any one of the following documents:</Text>

        <div>
          <BoldText>Payslips</BoldText>
          <StyledUL>
            <StyledLI>
              Is a PDF, screenshot or photo of a full computer-generated payslip
            </StyledLI>
            <StyledLI>Shows your full name</StyledLI>
            <StyledLI>Your employer's name</StyledLI>
            <StyledLI>
              Most recent payment is dated within the last 31 days
            </StyledLI>
            <StyledLI>
              Includes <strong> minimum 2 months of year-to-date </strong>{' '}
              income or supply <strong> 2 consecutive payslips</strong>
            </StyledLI>
            <StyledLI>
              Shows either Net or Gross income and frequency of pay
            </StyledLI>
          </StyledUL>
        </div>
        <div>
          <BoldText>Bank Statement / Online Transaction History</BoldText>
          <StyledUL>
            <StyledLI>Shows your BSB, account number & account name</StyledLI>
            <StyledLI>
              Two months of income payments, most recent income showing within
              the last 31 days
            </StyledLI>
            <StyledLI>
              Employer's name or ACN/ABN corresponding to the deposits
            </StyledLI>
          </StyledUL>
        </div>
      </ContentBox>
    )
  },
  {
    id: 'Self-Employed / Subcontractor',
    title: 'Self-Employed / Subcontractor',
    content: (
      <ContentBox>
        <ImportantInfoBox />
        <div>
          <BoldText>Tax Office Notice of Assessment</BoldText>
          <StyledUL>
            <StyledLI>Shows Australian Taxation Office details</StyledLI>
            <StyledLI>
              Is for End of Financial Year date within the last 18 months
            </StyledLI>
            <StyledLI>Shows the taxable income</StyledLI>
          </StyledUL>
        </div>
        <div>
          <BoldText>Accountant Letter</BoldText>
          <StyledUL>
            <StyledLI>
              Shows your accountant's name, address, ABN/ACN and telephone
              number
            </StyledLI>
            <StyledLI>Is dated within the last 31 days</StyledLI>
            <StyledLI>
              States your income after expenses for the last 2 months
            </StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>Tax Return</BoldText>
          <StyledUL>
            <StyledLI>
              Is prepared by an accountant with accountant details included
            </StyledLI>
            <StyledLI>
              End of Financial Year date within the last 18 months,
            </StyledLI>
            <StyledLI>
              Includes all pages of the “accountant prepared individual Tax
              Return”
            </StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>Profit and Loss Statement</BoldText>
          <StyledUL>
            <StyledLI>
              Is prepared by an accountant with accountant details included
            </StyledLI>
            <StyledLI>
              End of Financial Year date within the last 18 months
            </StyledLI>
            <StyledLI>Specifies you as a sole trader</StyledLI>
          </StyledUL>
        </div>
      </ContentBox>
    )
  },
  {
    id: 'If you receive Government Benefits',
    title: 'If you receive Government Benefits',
    content: (
      <ContentBox>
        <ImportantInfoBox />

        <div>
          <BoldText>Bank Statement / Online Transaction History</BoldText>
          <StyledUL>
            <StyledLI>Shows your BSB, account number & account name</StyledLI>
            <StyledLI>
              Two consecutive income payments, most recent income showing within
              the last 31 days
            </StyledLI>
            <StyledLI>Shows deposit amounts and dates</StyledLI>
            <StyledLI>
              Shows identifiable income transaction, e.g. Centrelink
            </StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>
            Centrelink / Services Australia Statement / Letter
          </BoldText>
          <StyledUL>
            <StyledLI>Shows the Agency name</StyledLI>
            <StyledLI>Benefit type, amount and frequency</StyledLI>
            <StyledLI>Is dated within the last 31 days</StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>
            Centrelink/ Services Australia Online Payment History
          </BoldText>
          <StyledUL>
            <StyledLI>Shows the Agency name</StyledLI>
            <StyledLI>Benefit type, amount and frequency</StyledLI>
            <StyledLI>
              Two consecutive income payments, most recent income showing within
              the last 31 days
            </StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>Veterans Affairs Statement / Letter</BoldText>
          <StyledUL>
            <StyledLI>Shows income amount and frequency</StyledLI>
            <StyledLI>
              Is on DVA letterhead, dated within the last 31 days
            </StyledLI>
          </StyledUL>
        </div>
      </ContentBox>
    )
  },
  {
    id: 'If you recevive Rental Income',
    title: 'If you recevive Rental Income',
    content: (
      <ContentBox>
        <ImportantInfoBox />
        <div>
          <BoldText>Bank Statement / Online Transaction History</BoldText>
          <StyledUL>
            <StyledLI>Shows your BSB, account number & account name</StyledLI>
            <StyledLI>
              Two months of income payments, most recent income showing within
              the last 31 days
            </StyledLI>
            <StyledLI>
              Tenant or rental agency's name corresponding to the deposits
            </StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>Real Estate Rental Statements or Receipts</BoldText>
          <StyledUL>
            <StyledLI>Shows the last 2 month's rental income</StyledLI>
            <StyledLI>
              Most recent rental statement or receipt dated within the last 31
              days
            </StyledLI>
            <StyledLI>
              Shows the Real Estate Agent's name, ACN /ABN, address and
              telephone number
            </StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>
            Current Rental Agreement (only for newly signed leases)
          </BoldText>
          <StyledUL>
            <StyledLI>Is current, formally executed</StyledLI>
            <StyledLI>Shows tenant's name</StyledLI>
            <StyledLI>Term of rental agreement</StyledLI>
            <StyledLI>Gross rental income</StyledLI>
            <StyledLI>Contracting parties signatures</StyledLI>
            <StyledLI>
              Accompanied with another rental income document if over 4 weeks
              old
            </StyledLI>
          </StyledUL>
        </div>
      </ContentBox>
    )
  },
  {
    id: 'Self-funded Retirees',
    title: 'Self-funded Retirees',
    content: (
      <ContentBox>
        <ImportantInfoBox />

        <div>
          <BoldText>Bank Statement / Online Transaction History</BoldText>
          <StyledUL>
            <StyledLI>Shows your BSB, account number & account name</StyledLI>
            <StyledLI>
              Three months of income payments, most recent income showing within
              the last 31 days
            </StyledLI>
            <StyledLI>
              If latest payment is not within 31 days provide with another
              income document
            </StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>Tax Office Notice of Assessment</BoldText>
          <StyledUL>
            <StyledLI>Shows Australian Taxation Office details</StyledLI>
            <StyledLI>
              Is for End of Financial Year date within the last 18 months
            </StyledLI>
            <StyledLI>Shows the taxable income</StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>Accountant Letter</BoldText>
          <StyledUL>
            <StyledLI>
              Shows your accountant's name, address, ABN/ACN and telephone
              number
            </StyledLI>
            <StyledLI>Is dated within the last 31 days</StyledLI>
            <StyledLI>
              States your income after expenses for the last 3 months
            </StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>Tax Return</BoldText>
          <StyledUL>
            <StyledLI>
              Is prepared by an accountant with accountant details included
            </StyledLI>
            <StyledLI>
              End of Financial Year date within the last 18 months
            </StyledLI>
            <StyledLI>
              Includes all pages of the “accountant prepared individual Tax
              Return”
            </StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>Superannuation Statement</BoldText>
          <StyledUL>
            <StyledLI>
              Shows superannuation provider name, ABN/ACN and address
            </StyledLI>
            <StyledLI>Issued within the last 45 days</StyledLI>
            <StyledLI>Shows net or gross income</StyledLI>
            <StyledLI>Shows benefit type, amount and frequency</StyledLI>
            <StyledLI>Current balance of the fund</StyledLI>
          </StyledUL>
        </div>

        <div>
          <BoldText>Letter from Superannuation Fund</BoldText>
          <StyledUL>
            <StyledLI>Shows fund name and ABN/ACN</StyledLI>
            <StyledLI>Isued within the last 31 days</StyledLI>
            <StyledLI>Shows net or gross income</StyledLI>
            <StyledLI>Pay frequency</StyledLI>
          </StyledUL>
        </div>
      </ContentBox>
    )
  },
  {
    id: 'Workers Compensation',
    title: 'Workers Compensation',
    content: (
      <ContentBox>
        <ImportantInfoBox />
        <div>
          <BoldText>Letter from Insurer</BoldText>
          <StyledUL>
            <StyledLI>
              Shows name of insurer or relevant body administering payments
            </StyledLI>
            <StyledLI>Start date of payments</StyledLI>
            <StyledLI>
              The end date (if applicable), and the amount and frequency of
              payments
            </StyledLI>
            <StyledLI>Is dated within the last 31 days</StyledLI>
          </StyledUL>
        </div>
      </ContentBox>
    )
  },
  {
    id: 'If you receive child support',
    title: 'If you receive child support',
    content: (
      <ContentBox>
        <ImportantInfoBox />
        <div>
          <BoldText>
            Legal Documentation or Child Support Agency Documentation
          </BoldText>
          <StyledUL>
            <StyledLI>
              Accompanied by your bank statement showing 2 months of income
              payments
            </StyledLI>
            <StyledLI>Most recent income within the last 31 days</StyledLI>
          </StyledUL>
        </div>
      </ContentBox>
    )
  }
];

const CustomAccordion = () => {
  return (
    <StyledAccordion isChild titleBgColor="grey-light" items={accordionData} />
  );
};

export default CustomAccordion;
